<mat-card *ngIf="selectedGroup$ | async as group">
  <div class="selected-section selected-section__title" [ngClass]="{'dark-theme': isDarkTheme$ | async}">
    <div>{{group.description}} (Group)</div>
    <div class="button button__light-blue" (click)="closeOutputs(group)">
      <div class="icon-lock-down"></div>
      <div>Lock down</div>
    </div>
  </div>
  <div class="selected-section" [ngClass]="{'dark-theme': isDarkTheme$ | async}">
    <div>Number of doors in area: {{group.outputs.length}}</div>
  </div>
  <div class="selected-section " [ngClass]="{'dark-theme': isDarkTheme$ | async}">
    <div class="margin__top--20 margin__bottom--20">
      <div class="flex justify-content--space-between margin__bottom--20 align-items--center">
        <div>Locked: {{group.lockedOutputs.length}}</div>
        <div class="button button__light-blue" (click)="openOutputs(group)">
          <div class="icon-unlock"></div>
          <div>Release all</div>
        </div>
      </div>
      <div class="flex justify-content--space-between margin__bottom--20 align-items--center">
        <div>Unlocked: {{group.unlockedOutputs.length}}</div>
        <div class="button button__light-blue" (click)="closeOutputs(group)">
          <div class="icon-lock-all"></div>
          <div>Lockdown all</div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
